import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class SmsService {

  constructor(private http: HttpClient) { }

  getSMSDashboard(payload): Observable<any> {
    let params = new HttpParams();
    params = params.append('startTime', payload.startTime);
    params = params.append('endTime', payload.endTime);
    return this.http.get<any>(urls.BASE_URL + urls.GET_SMS_DASHBOARD_DATA, {params})
      .pipe(
        catchError(errorHandl)
      );
  }

  
}
